import { render, staticRenderFns } from "./pizza.vue?vue&type=template&id=4274e255&scoped=true&"
import script from "./pizza.vue?vue&type=script&lang=js&"
export * from "./pizza.vue?vue&type=script&lang=js&"
import style0 from "./pizza.vue?vue&type=style&index=0&id=4274e255&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4274e255",
  null
  
)

export default component.exports